import { render } from "./PublicationChatRoom.vue.js?vue&type=template&id=f9088334&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationChatRoom.vue?vue&type=template&id=f9088334&scoped=true"
import script from "./PublicationChatRoom.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationChatRoom.vue?vue&type=script&lang=js"
export * from "./PublicationChatRoom.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationChatRoom.vue?vue&type=script&lang=js"

import "./PublicationChatRoom.vue.scss?vue&type=style&index=0&id=f9088334&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationChatRoom.vue?vue&type=style&index=0&id=f9088334&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9088334"],['__file',"src/Web/scripts/pages/publication/PublicationChatRoom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9088334"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9088334', __exports__)) {
    api.reload('f9088334', __exports__)
  }
  
  module.hot.accept("./PublicationChatRoom.vue.js?vue&type=template&id=f9088334&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationChatRoom.vue?vue&type=template&id=f9088334&scoped=true", () => {
    api.rerender('f9088334', render)
  })

}


export default __exports__